import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import api from '@alweb-merkator/shared/services/api';

import { useTranslation } from 'react-i18next';
import { Tradutor } from '@alweb-merkator/shared/components/I18n';

import {
  BannerInternas,
  Col,
  Conteudo,
  Row,
  Secao,
  SecaoBotaoVoltar,
  SecaoCabecalho,
  SecaoSubTitulo,
  SecaoTitulo,
  Iframe,
} from './styles';
import { useParams } from 'react-router';

const SecaoSerraPark = ({ idPage, ...props }) => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const secaoId = t('slugs.fenac');
  const [serraPark, setSerraPark] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    _handleGetGramdo();
    return function cleanup() {};
  }, []);

  const _handleGetGramdo = async () => {
    await api.get(`/blnews/${idPage}`).then((response) => {
      const dados = response.data[0];
      const dado = {
        title: '',
        content: '',
        image: dados.image,
        image_description: dados.image_description,
      };

      if (lang !== 'pt') {
        dado.title = dados['title_' + lang];
        dado.content = dados['content_' + lang];
        dado.description = dados['description_' + lang];
      } else {
        dado.title = dados.title;
        dado.content = dados.content;
        dado.description = dados.description;
      }
      setSerraPark(dado);
      setIsLoading(true);
    });
  };
  return (
    <Secao id={secaoId} className="mb-4">
      <SecaoCabecalho>
        <SecaoTitulo>
          <Tradutor path={isLoading ? serraPark.title : ''} />
        </SecaoTitulo>
        <SecaoBotaoVoltar />
      </SecaoCabecalho>

      <SecaoSubTitulo className="mb-4">
        <Tradutor path={isLoading ? serraPark.description : ''} />
      </SecaoSubTitulo>

      <BannerInternas
        src={isLoading ? serraPark.image : ''}
        alt={isLoading ? serraPark.image_description : ''}
        className="mb-4 mt-30"
      />

      <Row>
        <Col md="12">
          <Conteudo
            className="mb-4"
            dangerouslySetInnerHTML={{
              __html: isLoading ? serraPark.content : '',
            }}
          />
        </Col>
        <Col md="12">
          <Iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1264.658699180919!2d-51.135940522047925!3d-29.702351860538577!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9519425659e7aec9%3A0x5f7d7083ed4a6a9b!2sAv.%20Na%C3%A7%C3%B5es%20Unidas%2C%203827%20-%20Rio%20Branco%2C%20Novo%20Hamburgo%20-%20RS%2C%20Brasil!5e0!3m2!1spt-BR!2spt!4v1755075445268!5m2!1spt-BR!2spt"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          />
        </Col>
      </Row>
    </Secao>
  );
};
SecaoSerraPark.propTypes = {
  idPage: PropTypes.any,
};
export default SecaoSerraPark;
